import React from 'react';
import "./NavBar.css";
function NavBar() {
  return (
   
              <div className="header">
        <div className="navigation.pxy__30">
          <ul className="navbar d__flex">
            <a href="#Home">
              <li className="nav__items mx__15">Home</li>
            </a>
            <a href="#Book">
              <li className="nav__items mx__15">Book</li>
            </a>
            {/* <a href="#Subscription">
            <li className="nav__items mx__15">Subscription</li>
          </a>
          <a href="#Payment">
            <li className="nav__items mx__15">Payment</li>
          </a> */}
            <a href="#About">
              <li className="nav__items mx__15">About</li>
            </a>
            {/* <a href="#Portfolio">
              <li className="nav__items mx__15">Portfolio</li>
            </a> */}
            <a href="#Contact">
              <li className="nav__items mx__15">Contact</li>
            </a>

           </ul>
        </div>
      </div>
  )
}

export default NavBar;
